// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_WHERE_IS_DISCUSSED = "Kde se diskutuje";
export const HOME_RIGHT_LATEST_REVIEWS = "Nejnov\u011bj\u0161\u00ed hodnocen\u00ed";
export const HOME_RIGHT_MORE_REVIEWS = "Dal\u0161\u00ed hodnocen\u00ed...";
